import ComposeSmartPillStore from './schema/ComposeSmartPillStore';
import { createStore } from 'satcheljs';
import getInitialStore from '../utils/getInitialStore';

const composeSmartPillStore: ComposeSmartPillStore = getInitialStore();

const getStore = createStore<ComposeSmartPillStore>('composeSmartPill', composeSmartPillStore);
export default getStore;
